var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgVerified = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "var(--verifiedIconBgColor, var(--primary-color)",
  d: "M11.576 2.66a.61.61 0 0 1 .848 0l1.772 1.715a.61.61 0 0 0 .51.165l2.441-.345a.61.61 0 0 1 .686.498l.426 2.429a.61.61 0 0 0 .314.433l2.179 1.156a.61.61 0 0 1 .262.806l-1.083 2.215a.61.61 0 0 0 0 .536l1.083 2.215a.61.61 0 0 1-.262.806l-2.178 1.156a.61.61 0 0 0-.315.433l-.426 2.43a.61.61 0 0 1-.686.497l-2.442-.345a.61.61 0 0 0-.509.165l-1.772 1.715a.61.61 0 0 1-.848 0l-1.772-1.715a.61.61 0 0 0-.51-.165l-2.441.345a.61.61 0 0 1-.686-.498l-.426-2.429a.61.61 0 0 0-.314-.433L3.248 15.29a.61.61 0 0 1-.262-.806l1.083-2.215a.61.61 0 0 0 0-.536L2.986 9.517a.61.61 0 0 1 .262-.806l2.179-1.156a.61.61 0 0 0 .314-.433l.426-2.43a.61.61 0 0 1 .686-.497l2.442.345a.61.61 0 0 0 .509-.165z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "var(--verifiedIconTickColor, var(--white)",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.492,
  d: "m9.314 11.886 2.072 2.094 3.314-3.77"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgVerified);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };